import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent({ fill = "#000", fillOpacity = "0.36", ...props }) {
  return (
    <Svg
      {...props}
      width={20}
      height={18}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M1.4 17.4l17.45-7.48a1 1 0 000-1.84L1.4.6a.993.993 0 00-1.39.91L0 6.12c0 .5.37.93.87.99L15 9 .87 10.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </Svg>
  );
}

export default SvgComponent;
